<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Daily Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Daily Reports</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify">
          <!-- <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Users</label
            >
            <div>
              <Multiselect
                v-model="selectedUsers"
                mode="tags"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="usersList"
              />
            </div>
          </div>

          <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Practices</label
            >
            <div>
              <Multiselect
                v-model="selectedPractice"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="practices"
              />
            </div>
          </div> -->
             <div class="col-2">
            <!-- <label class="boldText" style="margin-bottom: 0px !important"
              >Category</label
            > -->
            <div>
              <MultiSelect
                style="width: 220px"
                v-model="selectedVisitT"
                :options="visitTList"
                optionLabel="name"
                placeholder="Select Category"
                display="chip"
                @change="visitChange()"
              />
            </div>
            </div> 
          <div class="col-2">
              <!-- <label class="boldText" style="margin-bottom: 0px !important"
              >Reason</label
            > -->
            <div v-if="reasonD == false">
              <MultiSelect
                disabled
                style="width: 220px"
                v-model="selectedVisitR"
                :options="visitRList"
                optionLabel="reason"
                placeholder="Select Reason"
                display="chip"
                @change="visitReasonChange()"
              />
            </div>

             <div v-else>
              <MultiSelect
                style="width: 220px"
                v-model="selectedVisitR"
                :options="visitRList"
                optionLabel="reason"
                placeholder="Select Reason"
                display="chip"
                @change="visitReasonChange()"
              />
            </div>
            </div>
              <div class="col-2">
            <!-- <label class="boldText" style="margin-bottom: 0px !important"
              >Stage</label
            > -->
            <div>
              <MultiSelect
                style="width: 220px"
                v-model="selectedStageT"
                :options="stageTList"
                optionLabel="name"
                placeholder="Select Stage"
                display="chip"
                @change="stageChange()"
              />
            </div>
            </div>
          <div class="col-1">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    placeholder=""
                    v-model="filter.veinsId"
                    @change="applyDateClick()"
                    style="width: 100%"
                  />
                  <label id="font1">Veins ID</label>
                </span>
              </div>
            </div>
           <div class="col-1">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    placeholder=""
                    v-model="filter.externalId"
                    @change="applyDateClick()"
                    style="width: 100%"
                  />
                  <label id="font1">External ID</label>
                </span>
              </div>
            </div>
           <div class="col-1">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    placeholder=""
                    v-model="filter.firstName"
                    @change="applyDateClick()"
                    style="width: 100%"
                  />
                  <label id="font1">First Name</label>
                </span>
              </div>
            </div>
              <div class="col-1">
              <div class="form-group">
                <span class="p-float-label">
                  <InputText
                    type="text"
                    id=""
                    placeholder=""
                    v-model="filter.lastName"
                    @change="applyDateClick()"
                    style="width: 100%"
                  />
                  <label id="font1">Last Name</label>
                </span>
              </div>
            </div>
          <div class="col-sm-2">
            <input
              style="margin-bottom: 6px; margin-left: 20px"
              type="text"
              name="daterangePR"
              :value="initDatePR"
              @change="datePickerPR"
              @focus="datePickerPR"
            />
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="
                  position: absolute;
                  margin-top: -34px;
                  margin-left: 200px;
                "
              >
                <span class="ti-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <p></p>

        <div class="card p-3">
          <div class="table-responsive">
            <div
              class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
            >
              <div class="dataTables_length">
                <span style="margin-right: 10px"
                  ><label for="">Show </label>
                </span>
                <select
                  v-model="pageSize"
                  class="form-control form-control-sm"
                  aria-label="Default select example"
                  @change="pageChange(1)"
                >
                  <option selected>50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="2000">2000</option>
                  <option value="2000">3000</option>
                </select>

                <span style="margin-left: 10px">
                  <label for=""> Entries </label></span
                >
              </div>
              <!-- <div class="dataTables_filter">
                <span class="float-right">
                  <span style="margin-right: 10px"
                    ><label for="Search">Search:</label></span
                  >
                  <input
                    type="text"
                    @change="SearchDataTable()"
                    v-model="searchFilter"
                    name=""
                    id=""
                  />
                </span>
              </div> -->
            </div>
            <table
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
              id="home_2"
            >
              <thead class="thead-dark">
                <tr>
                  <th style="text-align: start">
                    PTID<span>
                      <button class="asc-desc-btn" @click="orderBy(0)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    External ID<span>
                      <button class="asc-desc-btn" @click="orderBy(1)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Name<span>
                      <button class="asc-desc-btn" @click="orderBy(2)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Category<span>
                      <button class="asc-desc-btn" @click="orderBy(3)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Reason<span>
                      <button class="asc-desc-btn" @click="orderBy(4)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    DOS<span>
                      <button class="asc-desc-btn" @click="orderBy(5)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Stage<span>
                      <button class="asc-desc-btn" @click="orderBy(6)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    TimeIn<span>
                      <button class="asc-desc-btn" @click="orderBy(7)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Current Step<span>
                      <button class="asc-desc-btn" @click="orderBy(8)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Step Acknowledged<span>
                      <button class="asc-desc-btn" @click="orderBy(9)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                  <th style="text-align: start">
                    Comment<span>
                      <button class="asc-desc-btn" @click="orderBy(10)">
                        &uarr; &darr;
                      </button>
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="inData.length == 0">
                  <td align="center" colspan="100">
                    <strong> No data available</strong>
                  </td>
                </tr>
                <tr v-for="(dat, ndx01) in inData" :key="ndx01">
                  <td>{{ dat.ptid }}</td>
                  <td>{{ dat.externalId }}</td>
                  <td>{{ dat.patientName }}</td>
                  <td>{{ dat.visitType }}</td>
                  <td>{{ dat.visitReason }}</td>
                  <td>{{ dat.dosStr }}</td>
                  <td>
                    <span v-if="dat.checkedoutPracticeId === '1'"
                      >Checked Out</span
                    >
                    <span v-else>{{ dat.currentStage }}</span>
                  </td>
                  <td>{{ dat.stageTimeStr }}</td>
                  <td>{{ dat.currentStep }}</td>
                  <td>{{ dat.stepAck }}</td>
                  <td>{{ dat.commentText }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--show pagination-->
          <nav aria-label="Page navigation" style="float: right">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
              <!--show pagination-->
              <li v-if="showPagesMin > 1">
                <button class="page-link" @click="pageChange(1)">
                  1
                </button>
              </li>
              <li v-if="showPagesMin > 1">
                <button disabled class="page-link disabledColor">
                  ...
                </button>
              </li>
              <!--show pagination-->
              <li
                v-for="pageNum in totalPages"
                :key="pageNum"
                class="page-item colorActive"
              >
                <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax">
                  <span v-if="pageNumber == pageNum"
                    ><button
                      class="page-link activeColor"
                      disabled
                      @click="pageChange(pageNum)"
                    >
                      {{ pageNum }}
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange(pageNum)">
                      {{ pageNum }}
                    </button></span
                  >
                </span>
              </li>

              <!--show pagination-->
              <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
                <button disabled class="page-link disabledColor">
                  ...
                </button>
              </li>
              <li v-if="totalPages > 10 && totalPages - 4 >= pageNumber">
                <button class="page-link" @click="pageChange(totalPages)">
                  {{ totalPages }}
                </button>
              </li>
              <!--show pagination-->
              <li class="page-item colorActive">
                <span v-if="pageNumber == totalPages">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
                </span>
              </li>
            </ul>
          </nav>
        </div>
        <!-- 
        <div class="card p-3">
          <div class="table-responsive">
            <table
              data-height="300"
              class="
                table
                display
                table-bordered
                text-center
                table-striped
                no-wrap
              "
              id="example23"
            >
              <thead class="thead-dark">
                <tr>
                  <th>PID</th>
                  <th>External ID</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Reason</th>
                  <th>DOS</th>
                  <th>Stage</th>
                  <th>TimeIn</th>
                  <th>Current Step</th>
                  <th>Step Acknowledged</th>
                  <th>Comment</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(dat, ndx01) in inData" :key="ndx01">
                  <td>{{dat.ptid}}</td>
                  <td>{{dat.externalId}}</td>
                  <td>{{dat.patientName}}</td>
                  <td>{{dat.visitType}}</td>
                  <td>{{dat.visitReason}}</td>
                  <td>{{dat.dosStr}}</td>
                  <td>
                  <span v-if="dat.checkedoutPracticeId === '1'">Checked Out</span>
                  <span v-else>{{dat.currentStage}}</span>
                  </td>
                  <td>{{dat.stageTimeStr}}</td>
                  <td>{{dat.currentStep}}</td>
                  <td>{{dat.stepAck}}</td>
                  <td>{{dat.comment}}</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div> -->
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import localMixin from "./Mixins/DailyReport";
//import axios from "axios";
import moment from "moment";
// import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "DailyReport",
  mixins: [localMixin],
  components: {
    // Multiselect,
  },

  data() {
    return {
      //visit Type/Reason
      reasonD: false,
      selectedVisitR: [],
      visitRVal: "",
      visitTypeVa: "",
      visitTList: [],
      selectedVisitT: [],
      visitType: [],
      reasonChange: false,
      visitRList: [],
      visitReason: [],
      visitReason_1: [],
      selectedStageT: [],
      stageTList: [],
      stageName: [],
      stageRVal: "",
      stageRVal_1: "",

      filter :{
        veinsId: "",
        category: "",
        reason: "",
        stage: "",
        step: "",
        externalId: "",
        firstName: "",
        lastName: "",
        phone: "",
        startDate: "",
        endDate: ""
      },
      firstName: "",
      lastName: "",
      nameArr: {},

      searchFilter: "",
      TimerObject: {},
      //Data table Stage
      pageNumber: 1,
      pageSize: 50,
      totalPages: 0,
      totalRows: 0,
      //show pagination
      showPagesMin: 1,
      showPagesMax: 5,
      sortColumn: 0,
      sortColumnOption: 0,

      inData: [],
      users: [],
      practices: [],
      usersList: ["A", "B", "C", "D"],
      selectedUsers: [],

      selectedPractice: "",

      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      dummyDate: moment(String(new Date())).format("YYYY-MM-DD"),
    };
  }, // data

  methods: {}, // methods

  computed: {}, // computed

  watch: {
    visitType: function (val) {
        this.visitTList = [];
        for (let i = 0; i < val.length; i++) {
          this.visitTList.push(val[i]);
        }
      },
    visitReason: function (val) {
      this.visitRList = [];
      for (let j = 0; j < val.length; j++) {
        this.visitRList.push(val[j]);
      }
    },
    stageName: function (val) {
      this.stageTList = [];
      for (let j = 0; j < val.length; j++) {
        this.stageTList.push(val[j]);
      }
    },
  }, //watch

  mounted() {
    this.loadInit();
    this.getVistReasnStage();
  }, // mounted
};
</script>

<style scoped>
#font1{
  font-weight: bold;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
.colorActive {
  color: #f95c2e;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
</style>